<template>
  <div
    ref="menu"
    class="dropdown"
    :class="{ 'is-active': isActive }"
  >
    <div class="dropdown-trigger">
      <button
        class="button is-small"
        aria-haspopup="true"
        @click="isActive = !isActive"
      >
        <span class="icon is-small">
          <img
            src="../assets/icons8-ellipsis-60.png"
            alt="Open menu"
          />
        </span>
      </button>
    </div>
    <div class="dropdown-menu">
      <div class="dropdown-content">
        <!-- @slot dropdown content -->
        <slot />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

/** An ellipsis with a dropdown menu, when clicked outside the dropdown it also closes the menu. */
export default defineComponent({
  data() {
    return {
      isActive: false
    }
  },
  mounted() {
    document.addEventListener('click', this.checkClick)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.checkClick)
  },
  methods: {
    checkClick(event) {
      if (!this.isActive) {
        return
      }
      if (!this.$refs.menu.contains(event.target)) {
        this.isActive = false
      }
    }
  }
})
</script>